import { render, staticRenderFns } from "./updateWord.vue?vue&type=template&id=612de238&scoped=true&lang=pug"
import script from "./updateWord.vue?vue&type=script&lang=js"
export * from "./updateWord.vue?vue&type=script&lang=js"
import style0 from "./updateWord.vue?vue&type=style&index=0&id=612de238&prod&lang=scss&scoped=true"
import style1 from "./updateWord.vue?vue&type=style&index=1&id=612de238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612de238",
  null
  
)

export default component.exports